<template>
  <div class="simple-gauge">
    <svg :width="width + margin.left + margin.right" :height="height + margin.top + margin.bottom">
      <g :style="{ 'transform': `translate(${margin.left}px, ${margin.top}px)` }">
        <g class="arc" :style="{ 'transform': `translate(${(width - margin.left - margin.right) / 2}px, ${height * (2 / 3)}px)` }">
          <path class="bg-arc" :d="bgPathDesc" />
          <path class="data-arc" :d="dataPathDesc" :fill="getColor(score)" />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import { scaleLinear } from 'd3-scale';
import { arc } from 'd3-shape';

export default {
  name: 'SimpleGauge',
  props: {
    score: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      width: 64,
      height: 50,
      margin: { top: 0, right: 0, bottom: 0, left: 0 },
      arcMin: (-Math.PI / 2) * 1.33,
      arcMax: (Math.PI / 2) * 1.33,
      dataDomain: [0, 50, 100],
      arcScale: scaleLinear(),
      arc: arc(),
      bgPathDesc: '',
    };
  },
  computed: {
    dataPathDesc() {
      const endAngle = this.arcScale(this.score);
      const arc = this.arc.endAngle(endAngle);

      return arc();
    },
  },
  created() {
    const radius = this.width / 2;

    this.arcScale.domain(this.dataDomain).range([this.arcMin, 0, this.arcMax]);

    this.arc
      .innerRadius(radius - 2)
      .outerRadius(radius)
      .startAngle(this.arcMin)
      .endAngle(this.arcMax);

    this.bgPathDesc = this.arc();
  },
  methods: {
    getColor(value) {
      return Math.round(value) >= 75 ? '#8bc34a' : '#f5a623';
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-arc {
  fill: rgba(0, 0, 0, 0.16);
}
</style>
